import { ChurchHistoryService, VisitedChurch } from 'src/app/shared/services/church-history.service';
import { Component, Inject, OnInit, DOCUMENT } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/services/global.service';
import { formatNumber, Location } from '@angular/common';
import { TenantService } from 'src/app/tenant/tenant.service';
import { AuthService } from '../account/auth.service';
import { AppService } from 'src/app/shared/services/app.service';

@Component({
    selector: 'app-switch-tenant',
    templateUrl: './switch-tenant.component.html',
    styleUrls: ['./switch-tenant.component.scss'],
    standalone: false
})
export class SwitchTenantComponent implements OnInit {
  isLoading: boolean = true;
  UnknownTenant: boolean = false;
  SwitchingChurch: boolean = false;
  churchId = '';
  currentChurch = '';
  recentChurches: VisitedChurch[] = [];
  connectionError = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public globalService: GlobalService,
    private router: Router, 
    private route: ActivatedRoute,
    private authService: AuthService,
    private tenantService: TenantService,
    private appService: AppService,
    private churchHistory: ChurchHistoryService
  ) { }

  ngOnInit(): void {
    this.currentChurch = this.globalService.subdomain === 'main' ? this.churchHistory.churches[0]?.id || '' : this.globalService.subdomain;
    this.churchId = '';
    this.recentChurches = this.churchHistory.churches;
    this.isLoading = false; 
  }

  async onSubmit(form: NgForm) {
    if (this.SwitchingChurch || !form.valid || !form.value.churchId?.trim()) {
      return;
    }
    var target = form.value.churchId.toLowerCase().trim();
    if (target === this.currentChurch) { await this.router.navigate(['/' + target + '/home']); return; }
    this.UnknownTenant = false;
    this.connectionError = false;
    this.SwitchingChurch = true;
    var tenant = form.value.churchId.toLowerCase().trim();
    let exists: boolean;
    try { exists = await this.tenantService.tenantExists(tenant); }
    catch { this.connectionError = true; this.SwitchingChurch = false; return; }
    if (!exists)
    {
      this.UnknownTenant = true;
      this.SwitchingChurch = false;
      return;
    }

    this.churchHistory.remember(tenant, this.recentChurches.find(c => c.id === tenant)?.name || tenant);
    this.clearAllCache();
    this.authService.logout(0);
    var userId = localStorage.getItem("CSBarCodeID");
    if (userId == null)
      userId = "";
    localStorage.setItem('tenant', tenant);
    this.appService.sendToNative(userId, tenant);
    let currentUrl = this.document.location.origin.toLowerCase().replace(this.globalService.subdomain.toLowerCase(), 
    'main') + '/' + tenant.toLowerCase() + '/home';
    this.globalService.subdomain = tenant;
    location.href = currentUrl;   
  }

  chooseChurch(church: VisitedChurch): void {
    this.churchId = church.id;
    this.UnknownTenant = false;
    this.connectionError = false;
  }

  clearAllCache()
  {
    caches.keys().then(cacheNames => {
      cacheNames.forEach(cacheName => {
        caches.delete(cacheName);
      });
    });
  }
}  

